// src/config/locations.ts

export interface OrgLocation {
  id: string;          // canonical ID used in tags & payload
  city: string;        // "Ravenel"
  state: string;       // "SC"
  fullName: string;    // "Ravenel, SC"
  address: string;     // full street address
  phone?: string;      // optional
  aliases?: string[];  // common speech to text variants
}

export const LOCATIONS: OrgLocation[] = [
  {
    id: "lot_boiling_springs",
    city: "Boiling Springs",
    state: "SC",
    fullName: "Boiling Springs, SC",
    address: "9050 Asheville Hwy, Boiling Springs, SC 29316",
    phone: "864-586-2900",
  },
  {
    id: "lot_conway",
    city: "Conway",
    state: "SC",
    fullName: "Conway, SC",
    address: "934 US-501, Conway, SC 29526",
    phone: "843-331-3408",
  },
  {
    id: "lot_moncks_corner",
    city: "Moncks Corner",
    state: "SC",
    fullName: "Moncks Corner, SC",
    address: "3212 S Live Oak Dr, Moncks Corner, SC 29461",
    phone: "843-291-7769",
    aliases: ["Monks Corner","Monk's Corner", "Munks Corner","Munx Corner","Moncks","Monks","Munks","Munx"],
  },
  {
    id: "lot_florence",
    city: "Florence",
    state: "SC",
    fullName: "Florence, SC",
    address: "2121 E Palmetto St, Florence, SC 29506",
    phone: "843-407-6419",
  },
  {
    id: "lot_lugoff",
    city: "Lugoff",
    state: "SC",
    fullName: "Lugoff, SC",
    address: "320 US-601, Lugoff, SC 29078",
    phone: "803-572-5652",
  },
  {
    id: "lot_ravenel",
    city: "Ravenel",
    state: "SC",
    fullName: "Ravenel, SC",
    address: "5538 Savannah Hwy, Ravenel, SC 29470",
    phone: "843-806-8594",
  },
  {
    id: "lot_cottageville",
    city: "Cottageville",
    state: "SC",
    fullName: "Cottageville, SC",
    address: "10257 Cottageville Hwy, Cottageville, SC 29435",
    phone: "843-636-0379",
    aliases: ["Cottage Bill","Cottage"],
  },
  {
    id: "lot_newberry",
    city: "Newberry",
    state: "SC",
    fullName: "Newberry, SC",
    address: "1926 Wilson Rd, Newberry, SC 29108",
    phone: "803-944-1159",
  },
  {
    id: "lot_west_union",
    city: "West Union",
    state: "SC",
    fullName: "West Union, SC",
    address: "195 SC-11, West Union, SC 29696",
    phone: "864-916-2626",
  },
  {
    id: "lot_longs",
    city: "Longs",
    state: "SC",
    fullName: "Longs, SC",
    address: "1700 Hwy 9 E, Longs, SC 29568",
    phone: "843-390-0922",
  },
  {
    id: "lot_lancaster",
    city: "Lancaster",
    state: "SC",
    fullName: "Lancaster, SC",
    address: "366 Lancaster Bypass E, Lancaster, SC 29720",
    phone: "803-285-3445",
  },
  {
    id: "lot_greenwood",
    city: "Greenwood",
    state: "SC",
    fullName: "Greenwood, SC",
    address: "2409 Montague Ave Ext, Greenwood, SC 29649",
    phone: "864-259-3305",
  },
  {
    id: "lot_graniteville",
    city: "Graniteville",
    state: "SC",
    fullName: "Graniteville, SC",
    address: "20 Chalk Bed Rd, Graniteville, SC 29829",
    phone: "803-392-7101",
  },
  {
    id: "lot_brunswick",
    city: "Brunswick",
    state: "GA",
    fullName: "Brunswick, GA",
    address: "6785 New Jesup Hwy, Brunswick, GA 31523",
    phone: "912-342-7027",
  },
  {
    id: "lot_vidalia",
    city: "Vidalia",
    state: "GA",
    fullName: "Vidalia, GA",
    address: "3107 North St E, Vidalia, GA 30474",
    phone: "478-484-4824",
  },
  {
    id: "lot_statesboro",
    city: "Statesboro",
    state: "GA",
    fullName: "Statesboro, GA",
    address: "8724 US-301 S, Statesboro, GA 30458",
    phone: "912-259-9905",
  },
  {
    id: "lot_conover",
    city: "Conover",
    state: "NC",
    fullName: "Conover, NC",
    address: "920 Conover Blvd W, Conover, NC 28613",
    phone: "828-465-6117",
  },
  {
    id: "lot_goldsboro",
    city: "Goldsboro",
    state: "NC",
    fullName: "Goldsboro, NC",
    address: "4282 US-70 E, Goldsboro, NC 27534",
    phone: "919-778-2727",
  },
  {
    id: "lot_forest_city",
    city: "Forest City",
    state: "NC",
    fullName: "Forest City, NC",
    address: "242 S Church St, Forest City, NC 28043",
    phone: "828-382-0167",
  },
  {
    id: "lot_lexington",
    city: "Lexington",
    state: "NC",
    fullName: "Lexington, NC",
    address: "1634 Old US Hwy 52, Lexington, NC 27295",
    phone: "336-300-8527",
  },
  {
    id: "lot_wilson",
    city: "Wilson",
    state: "NC",
    fullName: "Wilson, NC",
    address: "2900 Forest Hills Rd, Wilson, NC 27893",
    phone: "252-471-8650",
  },
  {
    id: "lot_bdc",
    city: "Orangeburg",
    state: "SC",
    fullName: "BDC Office",
    address: "3145 Magnolia St, Orangeburg, SC 29115",
    phone: "803-534-7314",
  },
];
